import React from 'react';
import PropTypes from 'prop-types';

const Progress = ({ numberOfSteps, currentStep, finishedColor, incompleteColor }) => {
  const color = currentStep + 1 == numberOfSteps ? finishedColor || '#1ACCF0' : incompleteColor || '#aaaaaa';
  return (
    <div
      style={{
        border: `1px solid ${ color }`,
        height: '10%',
        width: `${100 - (100 / numberOfSteps)}%`
      }}
    >
      <div
        style={{
          backgroundColor: color,
          width: `${(((currentStep) / (numberOfSteps - 1)) * (100))}%`,
          height: '100%',
          transitionProperty: 'width backgroundColor',
          transitionDuration: '2s',
          transitionTimingFunction: 'ease',
        }}
      >
      </div>
    </div>
  );
}

class Wizard extends React.Component {
  static propTypes = {
    /**
     * Required: tells the wizard which step is current.
     */
    currentStepNumber: PropTypes.number.isRequired,
    /**
     * Required: tells the wizard how to render each step:
     */
    steps: PropTypes.arrayOf(
     PropTypes.shape({
       titleComponent: PropTypes.element,
       bodyComponent: PropTypes.element
     })
    ).isRequired
  }
  render() {
    const { steps, currentStepNumber } = this.props;
    if(!steps) return <div>No steps.</div>;

    return (
      <div>
        <div style={{ height: 50 }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: -52,
            zIndex: 1,
            position: 'relative'
          }}>
            {steps.map(({ titleComponent }, idx) => {
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: `${100 / steps.length }%`,
                  }}
                  onClick={e => this.props.onClick(idx)}
                  key={idx}
                  >
                  <div>{titleComponent}</div>
                </div>
              );
            })}
          </div>
          <div style={{
            position: 'relative',
            height: 60,
            zIndex: 0
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%'
            }}>
              <Progress numberOfSteps={steps.length} currentStep={currentStepNumber} />
            </div>
          </div>
        </div>
        {steps.map(({ bodyComponent }, idx) => (
          <div style={{ display: currentStepNumber == idx ? 'block' : 'none' }} key={idx}>{bodyComponent}</div>
        ))}
      </div>
    )
  }
}

module.exports = Wizard;



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/plans_calculator/partials/Wizard.js